import { render, staticRenderFns } from "./ContatosTabela.vue?vue&type=template&id=3e49ecfa"
import script from "./ContatosTabela.vue?vue&type=script&lang=js"
export * from "./ContatosTabela.vue?vue&type=script&lang=js"
import style0 from "./ContatosTabela.vue?vue&type=style&index=0&id=3e49ecfa&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports